import { render } from "./RadioGroupInput.vue?vue&type=template&id=044863fb&scoped=true"
import script from "./RadioGroupInput.vue?vue&type=script&lang=js"
export * from "./RadioGroupInput.vue?vue&type=script&lang=js"

import "./RadioGroupInput.vue?vue&type=style&index=0&id=044863fb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044863fb"]])

export default __exports__